import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { ISiteConfigService } from '../../../core';
let template = require('./home-content-card.html');

class HomeContentCardComponent extends ComponentRegistration {

    constructor() {
        super('homeContentCard', {
            controller: HomeContentCardController,
            templateUrl: template,
            controllerAs: 'homeContentCard',
            bindings: {
                scope: "@",
                redirectRoute: "@",
                onSuccess: "&"
            }
        });
    }
}

interface IHomeContentCardController {
    validate(): void;
}

class HomeContentCardController implements IHomeContentCardController {
    private static $inject: Array<string> = ['$rootRouter', 'SiteConfig'];

    //bindings
    private scope: string;
    private redirectRoute: string;
    private onSuccess: Function;

    constructor(private $router: ng.Router,
        private SiteConfig: ISiteConfigService) {

    }

    public $onInit(): void {
        if (!this.scope) {
            throw "A Home Content scope is required";
        }
            
        console.log('HomeContentCardController activated');
    }

    public validate(): void {

    }

}

let hmcntcdComponent = new HomeContentCardComponent();
export default hmcntcdComponent;
export { hmcntcdComponent as HomeContentCardComponent, IHomeContentCardController, HomeContentCardController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/public/user-controls/home-content-card.ts